export const en = {
    home: {
        SLOGAN: 'Gooday™',
        GOODAYWIQ: 'What is Gooday™ ?',
        GOODAYWID: 'Gooday™ App is one of the products of GoodayOnline™. GoodayOnline™ is '+
        'a market and consumer focused data company in B2B2C digital marketing. Founded in 2019, '+
        'Gooday is headquartered in Addis Ababa, Ethiopia with second HQ in Herndon VA, USA. The '+
        'word "Gooday", while it has a well intentioned meaning in English, also means "business" or'+
        ' "errand" in Amharic. Gooday™ is an automation tool for business-to-business and business-to-consumer ecosystems.',
        GOODAYWHYQ: 'Why do you need Gooday™ ?',
        GOODAYNEED: 'You can use Gooday™ app to hire help for odd jobs and gigs or search for opportunities' + 
        ' from available listings. These odd jobs include : home cleaning maid services, cooking, gardening,' + 
        ' tutoring, home improvement, handyman, moving help and more ... This service is provided for FREE, so' + 
        ' if you have a phone then finding the next gig is only a tap away, and hiring much needed help is now ' + 
        'easier than ever.',
        GOODAYWHATELSEQ: 'What else ?',
        GOODAYWHATELSE: 'B2B2C digital marketing is the bread and butter of Gooday Online. Our marketing ' + 
        'automation tool puts our customers ahead of the pack at a fraction of the traditional marketing ' + 
        'and advertisement costs. Small businesses in Ethiopia are drawning under the loud noise and ' + 
        'congestion created by traditional marketing and advertisement. Gooday Online addresses these ' + 
        'business challenges through accurate data and technology.',

    },
    menuItems: {
        SIGNUP: 'Sign Up',
        SIGNIN: 'Sign In',
        HOME: 'Home',
        SETTINGS: 'Settings',
        SIGNOUT: 'SignOut',
        MYGOODAY: 'My Gooday',
    },
    myGooday: {
        SEARCH: 'search',
        POST: 'post',
        searchMenu: {
            HEADER: 'Select city, neighborhood and skills for your Gooday',
            SELECTCITY: 'Which city is your Gooday in ?',
            SELECTHOOD: 'Which Neighborhood is your Gooday ?',
            SELECTGOODAY: 'What Goodays are you interested in ?',
            FINDGOODAY: 'Find Gooday',
        },
    },
    postMenu: {
        NEWGOODAY: 'New Gooday',
        ITEM1: '1. Choose City',
        ITEM2: '2. Choose Neighborhoods (Maximum of 3)',
        ITEM3: '3. Choose Skills (Maximum of 3)',
        ITEM4: '4. Add some brief description of your skills and experience',
        ITEM6: '6. Do you agree to the Gooday Online privacy and data usage policy?',
        POST: 'Post Gooday',
        CITYERROR: 'City is required field',
        HOODERROR: 'Hood is required field',
        GIGERROR: 'Gig category is required',
        INTROERROR: 'Introduction is required',
        INTROMAXERROR: 'Max length of intro is 120 letters',
        POLICYERROR: 'You must agree to policy to continue!',

    },
    cities: {
        ADDISABABA: {
            NAME: 'Addis Ababa',
            neighborHood: {
                PIASA: 'Piasa',
                ARATKILO: '4kilo',
                KASANCHIS: 'Kasanchis',
                BOLE: 'Bole',
                MEXICO: 'Mexico',
                LAFTO: 'Lafto',
                KERA: 'Kera',
            },
        },
        DIREDAWA: {
            NAME: 'Dire Dawa',
            neighborHood: {

            },
        },
        MEKELE: {
            NAME: 'Mek\'ele',
            neighborHood: {

            },
        },
        BAHIRDAR: {
            NAME: 'Bahir Dar',
            neighborHood: {

            },
        },
        GONDER: {
            NAME: 'Gonder',
            neighborHood: {

            },
        },
        DESSIE: {
            NAME: 'Dessie',
            neighborHood: {

            },
        },
        AWASA: {
            NAME: 'Awasa',
            neighborHood: {

            },
        },
        JIMMA: {
            NAME: 'Jimma',
            neighborHood: {

            },
        },
        BISHOFTU: {
            NAME: 'Bishoftu',
            neighborHood: {

            },
        },
        HARAR: {
            NAME: 'Harar',
            neighborHood: {

            },
        },
        DEBREBIRHAN: {
            NAME: 'Debre Birhan',
            neighborHood: {

            },
        },
        JIGJIGA: {
            NAME: 'Jigjiga',
            neighborHood: {

            },
        },
        SHASHEMANAE: {
            NAME: 'Shashemanae',
            neighborHood: {

            },
        },

    },
    gigs: {
        FORSALE: 'For Sale',
        MAIDCOOKING: 'Maid - Cooking',
        MAIDCLEANING: 'Maid - Cleaning',
        MAIDNANNY: 'Maid - Nany',
        TUTOR: 'Tutor',
        DRIVER: 'Driver(Shoufer)',
        SATELLITEDISH: 'Satellite Dish Maintenance',
        COMPUTERMAINT: 'Computer Maintenance',
        CARPENTER: 'Carpenter',
        PLUMBER: 'Plumber',
        CARWASH: 'Car Wash',
        GARDENER: 'Gardener',
        TRASHPICKUP: 'Trash Pickup',
        BEUTYHAIR: 'Hair Dresser/Stylist',
        BARBER: 'Barber',
        BEUTYMAKEUP: 'Makeup Artist',
        MASSAGE: 'Masseuse/Masseur',
        ELECTRICIAN: 'Electrician',
        HOUSEPAINTING: 'House Painting',
        OTHER: 'Other - not listed'
    },
    signIn: {
        SIGNIN: 'Sign In',
        ENTERPHONE: 'Enter your phone number',
        VERIFYHINT: 'Tap Verify and wait for sign-in SMS code',
        NEWPHONE: 'This phone number is new to the system, please signup !',
        ENTERSMSCODE: 'Enter the SMS verification code you received',
        SMSFAILED: 'SMS verification failed, check your phone number and try again',
        BADSMSCODE: 'Invalid SMS token, request a token again!',
        VERIFY: 'Verify Phone',
        PHONEREQERROR: 'Phone number is required',
        PHONEDIGITSERROR: 'Phone number should be 9 digits',


    },
    signUp: {
        FIRSTNAME: 'First Name',
        LASTNAME: 'Last Name',
        PHONE: 'Phone',
        EMAIL: 'E-Mail',
        CONFIRMEMAIL:'Confirm your E-mail',
        CITY: 'City',
        ENTERCITY: 'Enter your city',
        POLICYAGREE: 'Do you agree to the Gooday Online privacy and data usage policy?',
        VERIFYHINT: 'Tap Verify Phone and wait for sign-up SMS code',
        ACCOUNTEXISTS: 'An account with this phone number exists, you are logged in.',
        ROUTEDSIGNUP: 'The phone number used for sign-in is new to the system, you need to register!',
        REGISTER: 'Register and Signin',
        CLEAR: 'clear',
        NAMELENERROR: 'Name must be at most 10 characters long',
        NAMEREQERROR: 'Name is Required',
        EMAILVALIDERROR: 'Must be a valid E-mail address',
        EMAILREQERROR: 'E-mail is Required',
        EMAILMATCHERROR: 'E-mails are not matching',
        POLICYERROR: 'You must agree to policy to continue!',
        CITYERROR: 'City is required field',
    },
    
}